(function (angular) {
    "use strict";

    angular
    .module("alk.services")
    .service("GeoParser", [function () {

        function convertCompassToLatLon(degree1, compass1, degree2, compass2) {
            // normalize degrees to use - when referring to West or South compass directions
            if (compass1 === "W" || compass1 === "S") {
                degree1 = "-" + degree1;
            }

            if (compass2 === "W" || compass2 === "S") {
                degree2 = "-" + degree2;
            }

            if ((compass1 === "W" || compass1 === "E") && (compass2 === "N" || compass2 === "S")) {
                return { lat: Number(degree2), lon: Number(degree1) };
            } else if ((compass1 === "N" || compass1 === "S") && (compass2 === "W" || compass2 === "E")) {
                return { lat: Number(degree1), lon: Number(degree2) };
            } else {
                return {};
            }
        }

        function getLatLon(input) {
            // cleanup input by removing explicit + sign
            input = input.replace("+", "");
            var latlon;
            var searchll;
            var matches;

            // matches positive decimal followed by compass direction, with comma or spaces following by the same thing
            var regexCompassPost = /^(\d+.{0,1}\d+)\s*([NSEW])[\s,]+(\d+.{0,1}\d+)\s*([NSEW])$/;

            // matches compass direction followed by decimal, with comma or spaces, followed by the same thing
            var regexCompassPre = /^([NSEW])\s*(\d+.{0,1}\d+)[\s,]+([NSEW])\s*(\d+.{0,1}\d+)$/;

            if ((matches = input.match(regexCompassPost))) {
                latlon = convertCompassToLatLon(matches[1], matches[2], matches[3], matches[4]);

            } else if ((matches = input.match(regexCompassPre))) {
                latlon = convertCompassToLatLon(matches[2], matches[1], matches[4], matches[3]);

            } else if ((searchll = input.split(/[\s,]+/)).length === 2) {
                //todo: if they can both be parsed as floats return them as lat/lon, otherwise null.
                latlon = { lat: Number(searchll[0]), lon: Number(searchll[1]) };
            }
            else {
                return null;
            }

            if (Math.abs(latlon.lat) < 90 && Math.abs(latlon.lon) < 180) {
                return latlon;
            }

            return null;
        }

        var parseCity = function (strAddr) {
          var pTxt = strAddr.trim();
          var pObj = {
            city: "",
            state: "",
            zip: "",
            error: 0,
            errorTxt: ""
          };
          if (pTxt !== null) {
            pTxt = pTxt.replace(/,/g, " ");
            pTxt = pTxt.replace(/\s{2,}/g, " ");
            var pVals = pTxt.split(" ");
            //console.log(pVals);

            var stateMarker = pVals.length;

            //test last 'word' or two for zip or postcode
            if (pVals[pVals.length - 1].match(/^\d{1,5}$|^\d{5}-\d{1,4}$|^[A-Za-z]\d[A-Za-z][-]?\d[A-Za-z]\d$/) !== null) {
              if (pVals[pVals.length - 1].match(/^[A-Za-z]\d[A-Za-z][-]\d[A-Za-z]\d$/) !== null) { //strip hypen from postcode if necessary
                pObj.zip = pVals[pVals.length - 1].replace("-", "");
              } else {
                pObj.zip = pVals[pVals.length - 1];
                stateMarker = pVals.length - 1;
              }
            } else if (pVals.length > 1 && pVals[pVals.length - 2].match(/^[A-Za-z]\d[A-Za-z]$/) !== null && pVals[pVals.length - 1].match(/^\d[A-Za-z]\d$/) !== null) {
              pObj.zip = pVals[pVals.length - 2] + pVals[pVals.length - 1];
              stateMarker = pVals.length - 2;
            }

            //walk the 'words' backwards and test for US or Canada State/province.  Need to add MX and EU codes
            for (var p = pVals.length - 1; p >= 0; p--) {
              if (_.find(STATES, { abbreviation: pVals[p].toUpperCase() }) !== undefined) {
                //if (typeof (states[pVals[p].toUpperCase()]) != "undefined") {
                pObj.state = pVals[p];
                stateMarker = p;
                break;
              }
            }

            if (!(pObj.zip !== "" && pVals.length === 1)) {
              for (var z = 0; z < stateMarker; z++) {
                if (typeof (pVals[z]) !== "undefined") {
                  pObj.city += pVals[z] + " ";
                }
              }
              pObj.city = pObj.city.trim();
            }

          }
          if (pObj.zip === "" && pObj.city === "") {
            pObj.error = 1;
            pObj.errorTxt = $translate.instant("controllers.searchController.NoZipOrCity");
          }
          return pObj;
        };

        return {
          getLatLon: getLatLon,
          parseCity:parseCity
        };
    }]);

})(window.angular);



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/Common/geoParser.js